import axios from "axios";

let cachedHospitalsPromise = null;

export function getHospitals() {
  if (cachedHospitalsPromise) {
    return cachedHospitalsPromise;
  }

  // Cache response - no need to hit the API every time
  cachedHospitalsPromise = axios.get(process.env.REACT_APP_API + "/hospitals").then((resp) => resp.data);
  return cachedHospitalsPromise;
}
